import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { SpinnerService } from '@shared-services/spinner.service';
import { AppConfig } from '@shared-configs/app-config';
import { AuthenticationService } from '@auth-services/authentication.service';
import { escapeHtml } from '@shared-helpers/html-escape';

@Injectable()
export class VbtInterceptor implements HttpInterceptor {
  constructor(private _authService: AuthenticationService,
    private _spinner: SpinnerService) {
    Swal.mixin({ heightAuto: false });
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // A transport/CORS/offline failure is not evidence that the session is invalid.
    // Keep the form and session so the caller can show its error and retry.
    if (err.status === 0) {
      return throwError(err);
    }

    if (err.status === 401 || err.status === 403) {
      this._authService.unauthorized();
      return throwError(err);
    }

    if (err.error?.ErrorCode === 'AUTH0003' && err.status === 400) {
      this._authService.unauthorized();
      //  Swal('', 'Oturum süreniz dolmuştur.', 'error');
      return throwError(err);
      // return Observable.throw(err);
    }

    if (err.error?.ErrorCode === 'AUTH0001' && err.status === 400) {
      this._authService.unauthorized();
      //  Swal('', 'Oturum süreniz dolmuştur.', 'error');
      return throwError(err);
      // return Observable.throw(err);
    }

    if (err.status === 500) {
      if (err.error == null) {
        return throwError(err);
      }

      const error = err.error;
      if (AppConfig.debug) {
        Swal.fire('Hata !', escapeHtml(error.Message), 'error');
      }
    
      return throwError(err);
    }

    return throwError(err);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    if (!req.url.match('Dashboard')) {
      this._spinner.showSpinner();
    }
  
    return next.handle(req).pipe(catchError(x => this.handleAuthError(x)),
      finalize(() => {
        this._spinner.hideSpinner();
      })
    )

  }
}
